/* eslint-disable */ import { DomainBuilder, DomainComponentOpticBuilder, InvariantBuilder, RecipeFactoryBuilder, createConstantExpressionFactory, createCustomExpressionFactory, createCustomInvariantFactory, createRelationFactory } from '@salsita-ai/platform-project-sdk/domain';
import { BackendData, FrontendData, PublishedData, SessionData } from './application-types.js';
import { $entityReflections, constants } from './enhanced-model.js';
import { AnyDomainEntity, RootEntity, aliases, entities, modelVersion } from './model/index.js';
const implementRelation = createRelationFactory(aliases);
export const relationExpressions = {
    Room: {
        $walls: implementRelation({
            kind: 'allOfType',
            target: 'Wall',
            cardinality: '0-N'
        }),
        $cornerFillers: implementRelation({
            kind: 'allOfType',
            target: 'CornerFiller',
            cardinality: '0-N'
        }),
        $items: implementRelation({
            kind: 'allOfType',
            target: 'RoomItem',
            cardinality: '0-N'
        }),
        $bottomWallItems: implementRelation({
            kind: 'allOfType',
            target: 'BottomWallItem',
            cardinality: '0-N'
        }),
        $appliances: implementRelation({
            kind: 'allOfType',
            target: 'Appliance',
            cardinality: '0-N'
        }),
        $cabinets: implementRelation({
            kind: 'allOfType',
            target: 'BottomCabinet',
            cardinality: '0-N'
        })
    },
    BottomCabinetAppliance: {
        $cabinet: implementRelation({
            kind: 'indirect',
            field: 'applianceId',
            target: 'BottomCabinetWithAppliance',
            cardinality: '1-1'
        })
    },
    BottomCabinetWithAppliance: {
        $appliance: implementRelation({
            kind: 'direct',
            field: 'applianceId',
            target: 'BottomCabinetAppliance',
            cardinality: '0-1'
        })
    },
    RoomItem: {
        $room: implementRelation({
            kind: 'allOfType',
            target: 'Room',
            cardinality: '1-1'
        })
    },
    Wall: {
        $room: implementRelation({
            kind: 'allOfType',
            target: 'Room',
            cardinality: '1-1'
        }),
        $cabinets: implementRelation({
            kind: 'indirect',
            field: 'wallId',
            target: 'BottomCabinet',
            cardinality: '0-N'
        }),
        $parts: implementRelation({
            kind: 'indirect',
            field: 'wallId',
            target: 'BottomPart',
            cardinality: '0-N'
        }),
        $wallAppliances: implementRelation({
            kind: 'indirect',
            field: 'wallId',
            target: 'BottomWallAppliance',
            cardinality: '0-N'
        }),
        $bottomItems: implementRelation({
            kind: 'indirect',
            field: 'wallId',
            target: 'BottomWallItem',
            cardinality: '0-N'
        }),
        $topItems: implementRelation({
            kind: 'indirect',
            field: 'wallId',
            target: 'TopWallItem',
            cardinality: '0-N'
        }),
        $countertopItems: implementRelation({
            kind: 'indirect',
            field: 'wallId',
            target: 'CountertopWallItem',
            cardinality: '0-N'
        })
    },
    BottomWallItem: {
        $wall: implementRelation({
            kind: 'direct',
            field: 'wallId',
            target: 'Wall',
            cardinality: '1-1'
        })
    },
    TopWallItem: {
        $wall: implementRelation({
            kind: 'direct',
            field: 'wallId',
            target: 'Wall',
            cardinality: '1-1'
        })
    },
    CountertopWallItem: {
        $wall: implementRelation({
            kind: 'direct',
            field: 'wallId',
            target: 'Wall',
            cardinality: '1-1'
        })
    },
    CornerFiller: {
        $room: implementRelation({
            kind: 'allOfType',
            target: 'Room',
            cardinality: '1-1'
        })
    },
    GrillBase: {
        $warmingDrawer: implementRelation({
            kind: 'direct',
            field: 'warmingDrawerId',
            target: 'LynxWarmingDrawer',
            cardinality: '0-1'
        })
    },
    LynxProfessionalOutdoorBeverageDispenserW24: {
        $towerKit: implementRelation({
            kind: 'direct',
            field: 'towerKitId',
            target: 'LynxProfessionalTapTowerKit',
            cardinality: '1-1'
        })
    },
    LynxProfessionalTapTowerKit: {
        $dispenser: implementRelation({
            kind: 'indirect',
            field: 'towerKitId',
            target: 'LynxProfessionalOutdoorBeverageDispenserW24',
            cardinality: '1-1'
        })
    },
    LynxProfessionalOutdoorIceMachineW15: {
        $drainPump: implementRelation({
            kind: 'direct',
            field: 'drainPumpId',
            target: 'LynxProfessionalOutdoorIceMachineDrainPump',
            cardinality: '1-1'
        })
    },
    LynxWarmingDrawer: {
        $cabinet: implementRelation({
            kind: 'indirect',
            field: 'warmingDrawerId',
            target: 'GrillBase',
            cardinality: '1-1'
        })
    }
};
export const constantExpressions = createConstantExpressionFactory({} // insert expression metas here, once ready
)(constants);
export const createRecipe = RecipeFactoryBuilder.forAliases(aliases).forEntities(AnyDomainEntity.reflections).withDefaults({}).build();
const staticViolations = {
    Wall: {
        isStackValid: {
            type: 'isStackValid',
            severity: 'fatal',
            message: 'There is no space. Clear up some more space to add new items.'
        }
    },
    Room: {
        gasNotAvailable: {
            type: 'gasNotAvailable',
            severity: 'fatal',
            message: "Can't have gas appliances in a room without gas"
        }
    }
};
export const implementCustomInvariants = createCustomInvariantFactory()(staticViolations);
export const invariantBuilder = new InvariantBuilder(aliases);
export const attachComponent = DomainComponentOpticBuilder.from(aliases);
export const implementCustomExpressions = createCustomExpressionFactory({} // TODO pass in meta-data once we have them
);
export const domainBuilder = DomainBuilder.from(entities, aliases, $entityReflections, RootEntity.types, modelVersion, PublishedData, SessionData, FrontendData, BackendData, false).withExpressions(constantExpressions).withExpressions(relationExpressions);

//# sourceMappingURL=implementation.js.map